import Entry from "./Entry";

export default class Company extends Entry {
  static type = "companies";

  get type(): string {
    return Company.type;
  }
  companyType!: string;
}
